// ResizeObserver Loop Error Fix Utility
// Khắc phục lỗi "ResizeObserver loop completed with undelivered notifications"

// Debounce function để tránh quá nhiều event
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Throttle function để giới hạn tần suất thực thi
export const throttle = (func, limit) => {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// Stabilize CSS transitions để tránh layout thrashing
export const stabilizeTransitions = () => {
  // Ngăn chặn rapid hover changes
  const cards = document.querySelectorAll('.attendance-card, .compact-attendance-bar');
  
  cards.forEach(card => {
    let hoverTimeout;
    
    const handleMouseEnter = () => {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        card.classList.add('hover-stabilized');
      }, 50);
    };
    
    const handleMouseLeave = () => {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        card.classList.remove('hover-stabilized');
      }, 50);
    };
    
    card.addEventListener('mouseenter', handleMouseEnter, { passive: true });
    card.addEventListener('mouseleave', handleMouseLeave, { passive: true });
  });
};

// Optimize animation performance
export const optimizeAnimations = () => {
  const animatedElements = document.querySelectorAll('.compact-attendance-bar, .attendance-btn');
  
  animatedElements.forEach(element => {
    element.style.willChange = 'transform';
    element.style.transform = 'translateZ(0)';
    element.style.backfaceVisibility = 'hidden';
  });
};

// Initialize fixes
export const initializeResizeObserverFix = () => {
  // Suppress ResizeObserver errors globally
  const originalError = window.console.error;
  window.console.error = (...args) => {
    const message = args[0];
    if (typeof message === 'string' && message.includes('ResizeObserver loop completed')) {
      // Suppress ResizeObserver errors
      return;
    }
    originalError.apply(console, args);
  };
  
  // Apply fixes when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      stabilizeTransitions();
      optimizeAnimations();
    });
  } else {
    stabilizeTransitions();
    optimizeAnimations();
  }
};

// Cleanup function
export const cleanupResizeObserverFix = () => {
  const cards = document.querySelectorAll('.attendance-card, .compact-attendance-bar');
  cards.forEach(card => {
    card.removeEventListener('mouseenter', () => {});
    card.removeEventListener('mouseleave', () => {});
  });
};
